module.exports = __webpack_public_path__ + "static/media/support.08dda31d.svg";